import ErrorInfo, { ErrorInfoProps } from '../../app/base/ErrorInfo/ErrorInfo';

const ErrorBoundary = ({ error, children, ...rest }: ErrorInfoProps) => {
  if (error) {
    return <ErrorInfo error={error} {...rest} />;
  }

  return children;
};

export default ErrorBoundary;
